module.exports = __webpack_public_path__ + "img/woman1.802c032e.png";